import * as Yup from 'yup';
import i18n from 'i18next';

export const ProfileSchema = Yup.object().shape({
  name: Yup.string().trim().required (i18n.t('Display name field is required')),

  nickname: Yup.string()
    .trim()
    .required(i18n.t('Username field is required'))
    .test('email_format', i18n.t('Only latin characters available'), nickname => {
      if (nickname && /[\u0250-\ue007,]+/g.test(nickname)) {
        return false;
      }
      return true;
    }),
  /*display_name: Yup.string().email().required(),
  about: Yup.string().max(200),
  subPrice: Yup.string().email().required(),
  location: Yup.string().email().required(),
  website: Yup.string().email().required(),
  avatar: Yup.string().email().required(),
  cover: Yup.string().email().required(),*/
});
